export default __webpack_public_path__ + "static/media/food_image.532447ea.png";